var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_468_10264)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_468_10264",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 11.7452 15.7452 1 29 1C42.2548 1 53 11.7452 53 25C53 38.2548 42.2548 49 29 49C15.7452 49 5 38.2548 5 25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 11.7452 15.7452 1 29 1C42.2548 1 53 11.7452 53 25C53 38.2548 42.2548 49 29 49C15.7452 49 5 38.2548 5 25Z",
    fill: "url(#paint0_linear_468_10264)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 25M53 25M53 25M5 25M29 1M53 25M29 49M5 25M29 49V47C16.8497 47 7 37.1503 7 25H5H3C3 39.3594 14.6406 51 29 51V49ZM53 25H51C51 37.1503 41.1503 47 29 47V49V51C43.3594 51 55 39.3594 55 25H53ZM29 1V3C41.1503 3 51 12.8497 51 25H53H55C55 10.6406 43.3594 -1 29 -1V1ZM29 1V-1C14.6406 -1 3 10.6406 3 25H5H7C7 12.8497 16.8497 3 29 3V1Z",
    fill: "white",
    mask: "url(#path-1-inside-1_468_10264)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_10264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6043 16.9125C28.6408 16.8387 28.6972 16.7766 28.7672 16.7332C28.8371 16.6898 28.9178 16.6667 29.0001 16.6667C29.0824 16.6667 29.1631 16.6898 29.2331 16.7332C29.303 16.7766 29.3594 16.8387 29.396 16.9125L31.3209 20.8117C31.4478 21.0683 31.635 21.2903 31.8665 21.4587C32.098 21.6271 32.3669 21.7368 32.6501 21.7783L36.9551 22.4083C37.0367 22.4201 37.1133 22.4546 37.1764 22.5077C37.2394 22.5608 37.2863 22.6304 37.3118 22.7088C37.3373 22.7872 37.3403 22.8712 37.3206 22.9512C37.3009 23.0312 37.2591 23.1041 37.2001 23.1617L34.0868 26.1933C33.8815 26.3934 33.7278 26.6404 33.6391 26.913C33.5504 27.1856 33.5293 27.4757 33.5776 27.7583L34.3126 32.0417C34.327 32.1232 34.3182 32.2071 34.2872 32.2839C34.2562 32.3607 34.2042 32.4272 34.1372 32.4758C34.0702 32.5245 33.9909 32.5533 33.9083 32.5591C33.8257 32.5648 33.7432 32.5472 33.6701 32.5083L29.8218 30.485C29.5682 30.3518 29.2861 30.2823 28.9997 30.2823C28.7133 30.2823 28.4312 30.3518 28.1776 30.485L24.3301 32.5083C24.2571 32.547 24.1746 32.5644 24.0922 32.5585C24.0097 32.5527 23.9305 32.5238 23.8637 32.4752C23.7968 32.4266 23.745 32.3601 23.714 32.2835C23.683 32.2069 23.6742 32.1231 23.6884 32.0417L24.4226 27.7592C24.4711 27.4764 24.4501 27.1862 24.3614 26.9134C24.2727 26.6406 24.119 26.3935 23.9134 26.1933L20.8001 23.1625C20.7406 23.105 20.6984 23.032 20.6784 22.9517C20.6584 22.8715 20.6613 22.7872 20.6868 22.7085C20.7124 22.6298 20.7595 22.5599 20.8228 22.5066C20.8862 22.4534 20.9632 22.4191 21.0451 22.4075L25.3493 21.7783C25.6328 21.7371 25.9021 21.6275 26.1339 21.4591C26.3658 21.2908 26.5532 21.0686 26.6801 20.8117L28.6043 16.9125Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_468_10264",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_468_10264"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_10264"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_468_10264"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_468_10264",
    result: "effect2_dropShadow_468_10264"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_468_10264",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_10264",
    x1: 5,
    y1: 1,
    x2: 53,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BAC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_10264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(19 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeader);
export default __webpack_public_path__ + "static/media/leader.f1960a547a98df4fb9ce7e925425142e.svg";
export { ForwardRef as ReactComponent };